module.exports = __webpack_public_path__ + "static/media/TTO.778983c9.svg";